import { CheckCircle2, AlertTriangle, Bot } from "lucide-react";

/** Returns the visual + copy for a quote's verification state.
 *  Falls back for old docs that only have `verified` boolean. */
export function verificationInfo(q) {
  const st = q?.verification_status
    || (q?.verified ? "verified" : "paraphrase");

  if (st === "verified") {
    return {
      key: "verified",
      Icon: CheckCircle2,
      label: "VERIFIED",
      tooltip: "Real quote. Real speaker. Real source link.",
      cls: "border-[#0000FF] text-[#0000FF]",
      dotCls: "bg-[#0000FF]",
    };
  }
  if (st === "ai_illustrated") {
    return {
      key: "ai_illustrated",
      Icon: Bot,
      label: "AI-ILLUSTRATED",
      tooltip: "Nobody actually said this (yet). AI wrote it to fill the archive.",
      cls: "border-[#FF3333] text-[#FF3333] bg-[#FFE9E9]",
      dotCls: "bg-[#FF3333]",
    };
  }
  // paraphrase
  return {
    key: "paraphrase",
    Icon: AlertTriangle,
    label: "PARAPHRASE",
    tooltip: "Editor's paraphrase — vibes preserved, exact words fudged.",
    cls: "border-[#0A0A0A]/40 text-[#0A0A0A]/70",
    dotCls: "bg-[#0A0A0A]/40",
  };
}

/** Small badge with icon + label. */
export function VerificationBadge({ q, size = "sm" }) {
  const info = verificationInfo(q);
  const { Icon, label, tooltip, cls } = info;
  const pad = size === "lg" ? "px-2.5 py-1.5 text-[11px]" : "px-2 py-1 text-[10px]";
  return (
    <span
      className={`inline-flex items-center gap-1 font-ui border ${cls} ${pad}`}
      title={tooltip}
      data-testid={`badge-${info.key}`}
    >
      <Icon size={size === "lg" ? 13 : 11} />
      {label}
    </span>
  );
}
